import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBidPackages = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M28 2C29.1046 2 30 2.89543 30 4V16C30 17.1046 29.1046 18 28 18H23V25C23 25.5523 22.5523 26 22 26C21.4477 26 21 25.5523 21 25V18H16C14.8954 18 14 17.1046 14 16V4C14 2.89543 14.8954 2 16 2H28ZM12 6V8H4V20H18C18 21.1046 17.1046 22 16 22H11V29C11 29.5523 10.5523 30 10 30C9.44772 30 9 29.5523 9 29V22H4C2.89543 22 2 21.1046 2 20V8C2 6.89543 2.89543 6 4 6H12ZM12 14.914V12.084L9.5 14.585L8.70711 13.7929L8.6129 13.7097C8.22061 13.4047 7.65338 13.4324 7.29289 13.7929C6.90237 14.1834 6.90237 14.8166 7.29289 15.2071L8.79289 16.7071L8.8871 16.7903C9.27939 17.0953 9.84662 17.0676 10.2071 16.7071L12 14.914ZM28 4H16V16H28V4ZM25.2903 9.1129C25.5953 8.72061 25.5676 8.15338 25.2071 7.79289C24.8166 7.40237 24.1834 7.40237 23.7929 7.79289L21 10.585L20.2071 9.79289L20.1129 9.7097C19.7206 9.40468 19.1534 9.43241 18.7929 9.79289C18.4024 10.1834 18.4024 10.8166 18.7929 11.2071L20.2929 12.7071L20.3871 12.7903C20.7794 13.0953 21.3466 13.0676 21.7071 12.7071L25.2071 9.20711L25.2903 9.1129Z"
	})
});
export default SvgBidPackages;
